/** @format */

import { useState } from "react";
import { BtnPrimary, CancelBtn } from "../global/btns/btns";
import HeadTitle from "../global/HeadTitle";
import InputField from "../inputs/inputField";
import { WarningIcon } from "../svg";
import validator from "validator";
import { useDispatch, useSelector } from "react-redux";
import { getClient, updateClient } from "../../services/clintServices";
import { useParams } from "react-router-dom";
import { Spinner1 } from "../spinners/Spinner1";

const initialState = {
  name: "",
  phone: "",
};
export const PersonalData = ({ block }) => {
  const { id } = useParams();
  //redux
  const dispatch = useDispatch();
  const clientState = useSelector((state) => state.clientSlice);
  //local state
  const [values, setValues] = useState(initialState);
  const [error, setError] = useState(initialState);

  const handleChange = ({ target }) => {
    setValues({ ...values, [target.name]: target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validPhone = validator.isMobilePhone(values.phone);

    if (!validPhone) {
      setError({ ...error, phone: "هذا الرقم غير صحيح" });
    }

    if (validPhone && values.name) {
      // Request here
      setError(initialState);
      dispatch(
        updateClient({
          method: "PUT",
          url: "/clients/" + id,
          data: { name: values.name, phone: values.phone },
        })
      ).then(() => {
        setValues(initialState);
        dispatch(getClient("/clients/" + id));
      });
    }
  };

  return (
    <div className='personal-data'>
      {clientState.loading && <Spinner1 />}
      <form className='personal-data__form' onSubmit={handleSubmit}>
        <InputField
          name='name'
          value={values.name}
          title='اسم المستخدم'
          note='(مطلوب)'
          error={error.name}
          placeholder='ادخل اسم المستحدم'
          onChange={handleChange}
        />
        <InputField
          name='phone'
          value={values.phone}
          title=' رقم الموبايل  '
          note='(مطلوب)'
          error={error.phone}
          placeholder='ادخل رقم الهاتف'
          onChange={handleChange}
        />
        {!block && (
          <div className='flex-between'>
            <BtnPrimary action='تعديل' />
            <CancelBtn />
          </div>
        )}
        {block && (
          <div className='col-flex'>
            <HeadTitle title='سبب الحظـــر :' />
            <p>الغاء الطلبات بعد طلبها اكتر من مرة .</p>
          </div>
        )}
      </form>

      <div className='personal-data__warning'>
        <WarningIcon />
        <p className='primary__text'>
          لاحظ ان هذه البيانات مهمة جدا لا يمكن تعديلها الا اذا طلب الكفيل هذا ,
          و لا يمكن تعديلها من قبل المشرف العام .
        </p>
      </div>
    </div>
  );
};
